import { render, staticRenderFns } from "./UiItemEntry.vue?vue&type=template&id=371a5c8a&"
import script from "./UiItemEntry.vue?vue&type=script&lang=js&"
export * from "./UiItemEntry.vue?vue&type=script&lang=js&"
import style0 from "./UiItemEntry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports